export const GET_STATISTIC = 'app/dashboard_data'
export const GET_STATISTIC_ADMIN = 'app/dashboard_data_admin'
export const GET_STATISTIC_ADMIN_USER = 'app/dashboard_data_admin_user'
